import { Tooltip } from "./Tooltip";

export function MenuItem ({clickHandler,icon,text,textClass='',tooltip='',show=true}) {
  return (show ?
    <div className="relative group">
      <button
        onClick={clickHandler}
        className={textClass + " flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-indigo-50 w-full text-left cursor-pointer"}
      >
        <i className={icon + ' fa-solid'}></i>
        {text}
      </button>
      <Tooltip text={tooltip} />
    </div> 
    :<></>
  );
}
